module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// ContentPager Widget

(function (fox, $) {
	'use strict';

	fox.registerWidget('ContentPager', {

		configure: function () {
			this.registerOptions('', {
				'embed.container': '#content-pager',
				'tpl.container': 'content_pager',
				autoRender: true,
				pagesCount: 5,
				scrollToTop: true,
				rppShow: false,
				newSelect: true,
				'handleDom.setPage.target': '.pagination .ch-page',
				'handleDom.jumpToPage': {
					event: 'keyup',
					target: '#jump-to-page',
					callback: '_handleEnterKey'
				},
				'handleDom.jumpToPageClick': {
					event: 'click',
					target: '.goto-page',
					callback: '_handleIconClick'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this._active = true;
			this.visual = !!this.getOption('tpl.container');

			this.callParent('init', arguments);

			var rpp = Number(this.dl.getRpp());
			var range = fox.utils.getRange(10, 50, 10);

			if (range.indexOf(rpp) === -1) {
				range.unshift(false);
			}

			if (this.getOption('rppShow')) {
				this.embedWidget('rpp', 'Control_Select', {
					'embed.container': '#pager-rpp-switcher',
					'select.options': range.map(function (v) {
						var option = {
							title: (v || rpp) + ' records per page',
							value: v || rpp
						};

						if (!v || rpp === v) option.selected = true;

						return option;
					}, this),
					'handleWom.setRpp': {
						event: 'change',
						widget: '@this',
						callback: '@parent:_handleRppChange'
					}
				});
			}
		},

		jumpToPage: function (page) {
			if (!page || page > this._pagerData.total || !fox.isNumeric(page)) {
				return;
			}

			this.changePage(page);
		},

		_handleEnterKey: function () {
			if (event.keyCode === 13) {
				this.changePage(this.getTargetPage());
			}
		},

		addedToDom: function () {
			var jDoc;

			jDoc = $(document);

			this.inputElem = this.dom1('input#jump-to-page');

			if (!this.getOption('scrollToTop')) return false;

			if (jDoc.scrollTop() > jDoc.height() * 0.2) {
				$('body, html').animate({
					scrollTop: 0
				}, 500);
			}
		},

		_handleRppChange: function(rpp) {
			this.dl.setRpp(rpp).load();
		},

		_handleIconClick: function () {
			this.jumpToPage(this.getTargetPage());
		},

		getTargetPage: function () {
			return this.inputElem.value;
		}

	}, 'Grid_Pager');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/contentPager.js
// module id = 296
// module chunks = 2